import React, { useMemo, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

const DocumentStatusFilter = ({ onChange }) => {
  const [value, setValue] = useState(null);

  const options = useMemo(
    () => [
      { value: 'PENDING', label: 'Pending' },
      { value: 'REJECTED', label: 'Rejected' },
      { value: 'APPROVED', label: 'Approved' },
      { value: 'VALIDATION_FAILED', label: 'Validation Failed' },
    ],
    [],
  );

  const handleChange = (_, selectedOption) => {
    setValue(selectedOption);
    onChange(selectedOption?.value || null);
  };

  return (
    <Autocomplete
      value={value}
      options={options}
      getOptionLabel={(option) => option.label || ''}
      isOptionEqualToValue={(option, selected) => option?.value === selected?.value}
      onChange={handleChange}
      renderInput={(params) => (
        <TextField {...params} label="Peppol Status" variant="outlined" size="small" sx={{ minWidth: 200 }} />
      )}
      clearOnBlur={false}
    />
  );
};

export default DocumentStatusFilter;
